/**
 * @generated SignedSource<<6ea6a38445548ed4c7cbe4b755c693b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CancelBookingAsCoachInput = {
  availabilityId: string;
  cancellationComment?: string | null;
  clientMutationId?: string | null;
};
export type cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation$variables = {
  input: CancelBookingAsCoachInput;
};
export type cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation$data = {
  readonly Coaching: {
    readonly cancelBookingAsCoach: {
      readonly clientMutationId: string | null;
    } | null;
  };
};
export type cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation = {
  response: cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation$data;
  variables: cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CoachingMutations",
    "kind": "LinkedField",
    "name": "Coaching",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "CancelBookingAsCoachPayload",
        "kind": "LinkedField",
        "name": "cancelBookingAsCoach",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientMutationId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5b484f18ece04a618e12c4c1e6329029",
    "id": null,
    "metadata": {},
    "name": "cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation",
    "operationKind": "mutation",
    "text": "mutation cancelAppointmentMessageCoachModal_CancelBookingAsCoachMutation(\n  $input: CancelBookingAsCoachInput!\n) {\n  Coaching {\n    cancelBookingAsCoach(input: $input) {\n      clientMutationId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "340ce6d80f29fed4db3de9390e816a6c";

export default node;
